import { render } from "./TotalPatrimony.vue?vue&type=template&id=48895ab8"
import script from "./TotalPatrimony.vue?vue&type=script&lang=js"
export * from "./TotalPatrimony.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tio-patinhas/tio-patinhas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__